module.exports = __webpack_public_path__ + "static/DetectiveGui0-ac8f0bf637e40adf312ea8321cf5d3f0.png";